import { screenCategory } from '../library';

export default class MobileMenu {

  constructor(menuSelector = '#block-mainnavigation .menu') {
    this.element = document.querySelector(menuSelector);

    if (!!this.element) {
      this.setup();
    } else {
      console.warn('Can not init Mobile Menu script');
    }
  }

  _closeMenu(item) {
    item.classList.remove('hover');

    // Hide children
    const children = item.querySelectorAll('li.hover');

    for (let k = 0; k < children.length; k++) {
      children[k].classList.remove('hover');
    }

    // Add/remove whole menu class
    if(this.element.querySelectorAll('.menu-item--expanded.hover').length > 0) {
      this.element.classList.add('hover-open');
    } else {
      this.element.classList.remove('hover-open');
    }
  }

  _openMenu(item, parentUL) {
    // Hide other open menus
    for (let j = 0; j < parentUL.children.length; j++) {
      if(parentUL.children[j] != item) {
        this._closeMenu(parentUL.children[j]);
      }
    }

    // Trigger hover class
    if(item.classList.contains('hover')) {
      this._closeMenu(item);
    } else {
      item.classList.add('hover');
    }
  };

  // legacy function Encore
  _eMenu(){
    const links = this.element.querySelectorAll('.menu-item--expanded > a');

    // // Exit when blurring menu
    // element.addEventListener('pointerleave', (e) => {
    //   console.log("BLUURRRR");
    //   if(element.classList.contains('hover-open')) {
    //     element.classList.remove('hover-open');
    //     for (let i = 0; i < LINKS.length; i++ ) {
    //       LINKS[i].parentElement.classList.remove('hover');
    //     }
    //   }
    // });

    // for (let i = 0; i < LINKS.length; i++) {
    //   const link = LINKS[i];

    Array.from(links).forEach((link) => {
      const item = link.parentElement;
      const parentUL = item.parentElement;

      link.addEventListener('click', (e) => {
        e.preventDefault();

        this._openMenu(item, parentUL);
      });
    });

    const top_menu_items = [...this.element.children].filter((item) => {
      return item.classList.contains('menu-item--expanded');
    });

    // for (let i = 0; i < top_menu_items.length; i++) {
    top_menu_items.forEach((item) => {
      const parentUL = item.parentElement;

      item.addEventListener('pointerenter', (e) => {
        if(e.pointerType !== 'mouse' || screenCategory() !== 'desktop') return;
        e.preventDefault();

        this._openMenu(item, parentUL);
      });

      item.addEventListener('pointerleave', (e) => {
        if(e.pointerType !== 'mouse' || screenCategory() !== 'desktop') return;

        this._closeMenu(item);
      });
    });
  }

  setup() {
    //create main navigation menu
    if (!this.element) {
      console.warn('No element found.');
      return;
    }

    this._eMenu();
  }
}
